const NON_NUMERIC_RE = /\D/g;

const extractDigitsFromString = (str: string) => str.replace(NON_NUMERIC_RE, '');

export default extractDigitsFromString;
